{
  "logout": "Déconnexion",
  "accessGranted": "Accès accordé",
  "addNewEntity": "Ajouter un nouveau profil",
  "viewAllProfiles": "Voir tous les profils",
  "language": "Langue",
  "resourcesArticles": "Articles de ressources",
  "contactSupport": "Contacter l'assistance",
  "updateAvatar": "Mettre à jour l'avatar",
  "notifications": "Paramètres de notification",
  "loginSettings": "Gérer la connexion"
}
